// Fail-closed configuration state (ADR-0011): rendered when Cognito is
// not configured (e.g. a personal deployed stage with no Cognito resources). The
// app is NOT rendered and NO identity is injected.
export function ConfigErrorScreen() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-ds-surface">
			<div className="max-w-md w-full text-center space-y-3 p-8">
				<h1 className="text-2xl font-bold text-ds-text">ATLAS</h1>
				<p className="text-sm text-ds-text">Sign-in is not available in this environment.</p>
				<p className="text-xs text-ds-text-muted">
					Authentication is not configured for this deployment. Contact an administrator.
				</p>
			</div>
		</div>
	)
}
